"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MERKLE_DISTRIBUTOR_ETH = exports.MERKLE_DISTRIBUTOR_IBEX_2 = exports.MERKLE_DISTRIBUTOR_IBEX = void 0;
const types_1 = require("../types");
exports.MERKLE_DISTRIBUTOR_IBEX = {
    [types_1.Networks.Polygon]: '0x9c7213207b5f8726164c96a76a4b9c0fbf984aba',
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Arbitrum]: '',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
exports.MERKLE_DISTRIBUTOR_IBEX_2 = {
    [types_1.Networks.Polygon]: '0x1c813cDd6dAecE2CB83C52F0798504e42816E9C5',
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Arbitrum]: '',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
exports.MERKLE_DISTRIBUTOR_ETH = {
    [types_1.Networks.Polygon]: '0x7ce2f634f0698ecdca051ef1dc4be96ef3d05a62',
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Arbitrum]: '',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
